import { TLogRecord } from '@/utils/logger/types';

export const detailsToString = ({ message, stack, ...details }: Partial<TLogRecord>) => {
  const original = stack ? `\n\n${stack}` : '';
  const formatted = Object.entries(details)
    .map(([key, value]) => `\t${key}: ${value}`)
    .join('\n');

  return `${message}\n${formatted}${original}`;
};
